var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 15.609C22.6569 15.609 24 16.9522 24 18.609V19.3236C24 22.9014 19.7895 25.609 14 25.609C8.21053 25.609 4 23.0423 4 19.3236V18.609C4 16.9522 5.34315 15.609 7 15.609H21ZM21 17.109H7C6.2203 17.109 5.57955 17.7039 5.50687 18.4645L5.5 18.609V19.3236C5.5 21.9981 8.88879 24.109 14 24.109C18.926 24.109 22.3548 22.0041 22.4955 19.485L22.5 19.3236V18.609C22.5 17.8293 21.9051 17.1886 21.1445 17.1159L21 17.109ZM14 1.60901C17.3137 1.60901 20 4.2953 20 7.60901C20 10.9227 17.3137 13.609 14 13.609C10.6863 13.609 8 10.9227 8 7.60901C8 4.2953 10.6863 1.60901 14 1.60901ZM14 3.10901C11.5147 3.10901 9.5 5.12373 9.5 7.60901C9.5 10.0943 11.5147 12.109 14 12.109C16.4853 12.109 18.5 10.0943 18.5 7.60901C18.5 5.12373 16.4853 3.10901 14 3.10901Z",
    fill: "#237FFF",
    stroke: "#237FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlue);
export default __webpack_public_path__ + "static/media/person-blue.2ebcd836375561be17f148f33f2f1da3.svg";
export { ForwardRef as ReactComponent };